import { Box, Heading, Text } from '@chakra-ui/react';

interface IProps {
  title: string;
  subtext?: string;
  'data-selector'?: string;
}

const SectionHeader = (props: IProps) => {
  const { title, subtext } = props;
  return (
    <Box data-selector={props['data-selector']} mt={10} mb={6}>
      <Heading as="h2" mb={2} fontSize="2xl">
        {title}
      </Heading>

      {subtext ? <Text color="muted">{subtext}</Text> : null}
    </Box>
  );
};

export default SectionHeader;
